import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { getFromLocalStorage, setInLocalStorage } from '@mobi/utils/storage'
import { sendToNative } from '@mobi/web-native-comms/web'
import { getCoords } from '@core/Areas/VenueMode/Store'
import { useSelector } from 'react-redux'
import { ImpreciseNotice } from './ImpreciseNotice'
import { OutsideNotice } from './OutsideNotice'
import { InsideNotice } from './InsideNotice'
import { useIsVenueModeActive } from '../../Hooks/useIsVenueModeActive'

const LocalStorageKey = 'venue-mode'

type StorableData = {
  hasDismissedInfo: boolean
}

export const Notices = (): React.JSX.Element => {
  const navigate = useNavigate()
  const geoLocation = useSelector(getCoords)
  const isVenueModeFeatureActive = useIsVenueModeActive()

  const readFromStorage = (): StorableData => {
    const retrieved = getFromLocalStorage(LocalStorageKey) || '{}'
    return (JSON.parse(retrieved) as StorableData) || { hasDismissedInfo: false }
  }

  const data = readFromStorage()
  const [doShowReminder, setDoShowReminder] = useState<boolean>(!data.hasDismissedInfo)

  const saveToStorage = (data: StorableData) => {
    const json = JSON.stringify(data)
    setInLocalStorage(LocalStorageKey, json)
  }

  const requestPreciseLocation = () => {
    sendToNative('LBS_LOCATION_NETWORK_REQUEST')
  }

  const handleDismissInfo = () => {
    setDoShowReminder(false)
    saveToStorage({ ...data, hasDismissedInfo: true })
  }

  if (!isVenueModeFeatureActive) {
    navigate('/')
    return <></>
  }
  if (!geoLocation.isEnabledHighAccuracy) {
    return <ImpreciseNotice onEnablePreciseLocation={requestPreciseLocation} />
  }

  if (!geoLocation.closestVenue?.inside) {
    return (
      <OutsideNotice
        closestVenue={geoLocation.closestVenue}
        onFindTab={() => navigate('/tablocator')}
      />
    )
  }
  if (doShowReminder) {
    return <InsideNotice onDismiss={handleDismissInfo} />
  }

  return <></>
}
